import React, { KeyboardEvent, useCallback } from "react";
import AccessoryLink from "@/components/accessory-link";
import Button from "@/components/button";
import Container from "@/components/container";
import Link from "@/components/text-link";
import SendIcon from "@/icons/send";
import { trackEvent } from "@/remote/tracking";

const Footer: React.FC = () => {
  const openMaps = useCallback(() => {
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(
      window.navigator.userAgent,
    );

    if (isMacLike) {
      window.open(
        "http://maps.apple.com/?daddr=kolossal+GmbH,+Viktoriastra%C3%9Fe+34-36,+44135+Dortmund",
        "_blank",
      );

      return;
    }

    window.open(
      "https://www.google.com/maps/dir/?api=1&destination=kolossal+GmbH,+Viktoriastra%C3%9Fe+34-36,+44135+Dortmund",
      "_blank",
    );

    trackEvent("Routenplanung gestartet");
  }, []);

  const horizontalListClassName =
    "flex flex-col space-y-xs md:flex-row md:space-y-0 md:space-x-md";

  return (
    <footer className="flex flex-col items-stretch font-medium leading-relaxed font-display pt-xl pb-[12vh] gap-xl">
      <Container className="my-base">
        <div className="text-lg-fluid md:text-xl-fluid">
          Wir waren noch nie bereiter.
        </div>
        <div className="tracking-tight text-4xl-fluid my-1f">
          Gehen wir’s an.
        </div>
        <Button
          to="mailto:hallo@kolossal.io"
          icon={SendIcon}
          className="my-base"
          onClick={() => trackEvent("Kontakt-Button geklickt")}
        >
          Kontakt aufnehmen
        </Button>
      </Container>
      <Container className="grid grid-cols-1 leading-loose gap-gutter-2x md:grid-cols-2 lg:grid-cols-4 lg:gap-gutter-3x">
        <div>
          <div className="mb-sm">
            <div>Dortmund</div>
            <div aria-hidden="true" className="font-normal">
              51°30&apos;48.5&quot;N 7°28&apos;17.0&quot;E
            </div>
          </div>
          <AccessoryLink
            aria-label="Route zum Standort planen"
            onClick={() => openMaps()}
            onKeyUp={(e: KeyboardEvent) => {
              if (e.key === "Enter") openMaps();
            }}
          >
            Route planen
          </AccessoryLink>
        </div>
        <div>
          Viktoriastraße 34-36
          <br />
          44135 Dortmund
        </div>
        <div>
          <ul>
            <li>
              <Link to="mailto:hallo@kolossal.io" className="py-1f">
                hallo@kolossal.io
              </Link>
            </li>
            <li>
              <Link to="tel:004923113712011" className="py-1f">
                0 231 137 12 011
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <ul aria-label="Soziale Netzwerke">
            <li>
              <Link
                to="https://www.instagram.com/kolossal.io/"
                className="py-1f"
              >
                Instagram
              </Link>
            </li>
            <li>
              <Link
                to="https://linkedin.com/in/bernhard-seltmann-538157174"
                className="py-1f"
              >
                LinkedIn
              </Link>
            </li>
          </ul>
        </div>
      </Container>
      <Container className={horizontalListClassName}>
        <div>&copy;{new Date().getFullYear()} kolossal GmbH</div>
        <nav>
          <ul className={horizontalListClassName}>
            <li>
              <Link to="/datenschutz">Datenschutz</Link>
            </li>
            <li>
              <Link to="/impressum">Impressum</Link>
            </li>
          </ul>
        </nav>
      </Container>
    </footer>
  );
};

export default Footer;
